import { render, staticRenderFns } from "./people-detail.vue?vue&type=template&id=fa1a87f6&scoped=true"
import script from "./people-detail.vue?vue&type=script&lang=js"
export * from "./people-detail.vue?vue&type=script&lang=js"
import style0 from "./people-detail.vue?vue&type=style&index=0&id=fa1a87f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1a87f6",
  null
  
)

export default component.exports